import { gql, useMutation } from '@apollo/client';
import { useAuth } from '../auth/useAuth';
import { useLogger } from '@amzn/xb-hooks';
import { WAITLIST_LEARNING_ACTIVITY_ERROR } from '../../common/rumMetrics';

export const WAITLIST_LEARNING_ACTIVITY = gql`
    mutation waitlistLearningActivity($userId: ID!, $learningActivityId: ID!) {
        waitlistLearningActivity(userId: $userId, learningActivityId: $learningActivityId) {
            id
            registrationStatus
        }
    }
`;

export const useWaitlistLearningActivity = (learningActivityId: string) => {
    const { log, count } = useLogger();
    const { user } = useAuth();
    return useMutation(WAITLIST_LEARNING_ACTIVITY, {
        variables: { userId: user.id, learningActivityId: learningActivityId },
        onError: (error) => {
            log.error('Error waitlisting learning activity', error);
            count(WAITLIST_LEARNING_ACTIVITY_ERROR);
        },
    });
};
